export enum DeviceStatus {
    Unknown = 0,
    NotVerified = 1,
    Verified = 2,
    Invalid = 3,
    Failed = 4
}
